import { getThreeDsChallengeDisplaySize, renderIframeAndWaitForPostback, ThreeDsFormattingException, } from '../3d-secure';
import { decodeBase64URL, encodeBase64URL } from '../base64url';
import { stringify } from '../../../utils';
import { logTaggedMessage } from '../../reporter';
import { collectBrowserInfo } from '../collectBrowserInfo';
import { threeDsErrors } from '../3ds-utils';
const log = logTaggedMessage({
    module: '3ds',
    sub_moodule: 'adyen-fingerprint',
});
const parseFingerprintPostData = (postData) => {
    if (typeof postData !== 'object' ||
        !postData.threeDSMethodData) {
        throw new ThreeDsFormattingException(`invalid FingerprintRawPostData: ${stringify(postData)}`);
    }
    let decoded;
    try {
        decoded = decodeBase64URL(postData.threeDSMethodData);
    }
    catch (e) {
        throw new ThreeDsFormattingException(`failed to decode invalid FingerprintRawPostData.threeDSMethodData: ${stringify(postData)}`);
    }
    let parsedObj;
    try {
        parsedObj = JSON.parse(decoded);
    }
    catch (e) {
        throw new ThreeDsFormattingException(`failed to JSON.parse invalid decoded FingerprintRawPostData.
        postData: ${stringify(postData)}
        threeDSMethodData: ${decoded}`);
    }
    if (typeof parsedObj.threeDSServerTransID !== 'string') {
        throw new ThreeDsFormattingException(`invalid FingerprintResponseData: ${decoded}`);
    }
    return parsedObj;
};
const encodeRequestData = (data) => {
    const encodedData = encodeBase64URL(JSON.stringify(data, null, 2));
    const postData = {
        threeDSMethodData: encodedData,
    };
    return postData;
};
export const performFingerprint = async ({ methodUrl, data: actionData, provider, notificationUrl, }) => {
    const challengeDisplaySize = getThreeDsChallengeDisplaySize();
    const browserInfo = collectBrowserInfo();
    const { threeDSServerTransID, threeDS2Token } = actionData;
    const dataToServer = {
        token: threeDS2Token,
    };
    const success = () => ({
        fingerprintData: {
            challengeDisplaySize,
            received: {},
            provider,
            data: dataToServer,
            browserInfo,
        },
    });
    const fail = (error) => {
        return {
            fingerprintData: {
                challengeDisplaySize,
                provider,
                notReceived: { error },
                data: dataToServer,
                browserInfo,
            },
        };
    };
    const reqData = {
        threeDSServerTransID,
        threeDSMethodNotificationURL: notificationUrl,
    };
    const rawPostData = encodeRequestData(reqData);
    const logData = {
        methodUrl,
        provider,
        actionData,
        notificationUrl,
        dataToServer,
        reqData,
        rawPostData,
    };
    log('3ds: before render 3ds Adyen fingerprint iframe', logData);
    if (!methodUrl) {
        const ret = fail(threeDsErrors.missingUrl('ADYEN', 'fingerprint'));
        log(`3ds: Adyen Device Fingerprint failed`, { ...logData, ret });
        return ret;
    }
    const fingerprintResultPromise = renderIframeAndWaitForPostback('hidden', methodUrl, 'POST', rawPostData).then(parseFingerprintPostData);
    try {
        const fingerprintResult = await fingerprintResultPromise;
        if (fingerprintResult.threeDSServerTransID !== threeDSServerTransID) {
            const err = `adyen fingerprint transactionId dont match!
        sent: ${threeDSServerTransID},
        recived: ${fingerprintResult.threeDSServerTransID}`;
            const ret = fail(err);
            log(`3ds: Adyen Device Fingerprint failed`, { ...logData, err, ret });
            return ret;
        }
        log('3ds: received Adyen fingerprint success', {
            ...logData,
            fingerprintResult,
        });
        return success();
    }
    catch (e) {
        const ret = fail(threeDsErrors.generate3dsError({
            providerFlow: 'ADYEN',
            step: 'fingerprint',
            e,
        }));
        log(`3ds: Adyen Device Fingerprint failed`, { ...logData, ret, e });
        return ret;
    }
};
//# sourceMappingURL=adyen-fingerprint.js.map